:host {
  display: block;
}

.alert {
  display: flex;
  padding: 1.6rem;
  border-radius: var(--border-radius, #{$border-radius});
  background: var(--background);
  position: relative;

  .alert__heading {
    align-items: center;
    display: flex;

    font-size: 1.6rem;
    @include font-weight(600);
    line-height: 1.3;
    letter-spacing: 0.015rem;
    color: var(--color);
  }

  .alert__heading ~ .alert__content {
    margin-top: 0.4rem;
  }

  ::slotted(o2-icon) {
    margin-right: 1.2rem;
    color: var(--color);
  }
}

.alert--transparent {
  padding: 0;
}

.alert--primary {
  --background: var(--o2-blue-action-light, #{$blue-action-light});

  .alert__heading {
    --color: var(--o2-blue-action, #{$blue-action});
  }

  ::slotted(o2-icon) {
    --color: var(--o2-blue-action, #{$blue-action});
  }

  .alert__close {
    --color: var(--o2-blue-action, #{$blue-action});

    &:hover {
      --color: var(--o2-blue-action-dark, #{$blue-action-dark});
    }
  }
}

.alert--success {
  --background: var(--o2-green-light, #{$green-light});

  .alert__heading {
    --color: var(--o2-green, #{$green});
  }

  ::slotted(o2-icon) {
    --color: var(--o2-green, #{$green});
  }

  .alert__close {
    --color: var(--o2-green, #{$green});

    &:hover {
      --color: var(--o2-green-dark, #{$green-dark});
    }
  }
}

.alert--warning {
  --background: var(--o2-orange-light, #{$orange-light});

  .alert__heading {
    --color: var(--o2-orange, #{$orange});
  }

  ::slotted(o2-icon) {
    --color: var(--o2-orange, #{$orange});
  }

  .alert__close {
    --color: var(--o2-orange, #{$orange});

    &:hover {
      --color: var(--o2-orange-dark, #{$orange-dark});
    }
  }
}

.alert--danger {
  --background: var(--o2-red-light, #{$red-light});

  .alert__heading {
    --color: var(--o2-red, #{$red});
  }

  ::slotted(o2-icon) {
    --color: var(--o2-red, #{$red});
  }

  .alert__close {
    --color: var(--o2-red, #{$red});

    &:hover {
      --color: var(--o2-red-dark, #{$red-dark});
    }
  }
}

.alert--purple {
  --background: var(--o2-purple-light, #{$purple-light});

  .alert__heading {
    --color: var(--o2-purple, #{$purple});
  }

  ::slotted(o2-icon) {
    --color: var(--o2-purple, #{$purple});
  }

  .alert__close {
    --color: var(--o2-purple, #{$purple});

    &:hover {
      --color: var(--o2-purple-dark, #{$purple-dark});
    }
  }
}

.alert--inline {
  @media screen and (min-width: 768px) {
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    min-height: 3.2rem;

    .alert__section {
      display: flex;
      align-items: center;
    }

    .alert__heading {
      margin-bottom: 0;
      margin-right: $spacing-2;
    }

    .alert__content {
      margin-top: 0 !important;
    }

    ::slotted(o2-button) {
      margin-top: 0;
      margin-left: $spacing-4;
    }
  }
}

.alert--closable {
  transition: all 0.3s var(--o2-transition);

  .alert__heading {
    margin-right: 1.6rem;
  }

  .alert__close {
    position: absolute;
    top: 1.6rem;
    right: 1.6rem;
    transition: opacity 0.3s var(--o2-transition);
    cursor: pointer;
  }

  &.alert--hidden {
    opacity: 0;
    visibility: hidden;
    height: 0;
    padding: 0;
    margin: 0;
  }
}

::slotted(p) {
  margin-bottom: 0 !important;
}

::slotted(o2-button) {
  margin-top: 1.6rem;
}
